import { createContext } from 'react';

const activitiesContext = createContext();

export default activitiesContext;